import { render, staticRenderFns } from "./svgGithub.vue?vue&type=template&id=8116582c&scoped=true"
import script from "./svgGithub.vue?vue&type=script&lang=js"
export * from "./svgGithub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8116582c",
  null
  
)

export default component.exports